/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { CheckboxComponent } from '../CMSDrug/CMSDrugInputContainer';
import { NDCDetailsTextFieldComponent } from '../NDCDetailsHeaderDetailsComponent';

const TabNDCDetailsInputContainer = ({ details, referenceData }) => {
  const getValueFromReferenceData = (referKey, inputValue) => {
    if (referenceData && referenceData[referKey] && inputValue) {
      const index = referenceData[referKey].findIndex(
        (item) =>
          item.codeValueID.codeDomainKey === referKey &&
          item.codeValueID.codeValue === inputValue
      );
      if (index !== -1) {
        return referenceData[referKey][index].shortDescription;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  return (
    <>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Drug Termination Date'}
          value={(details && details.drugTerminationDt) || ''}
          required={false}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Package Size'}
          value={(details && details.packageSize2) || ''}
          required={false}

        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'DESI Drug Code'}
          value={(details && details.desiDrugCd) || ''}
          required={false}

        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Package Type'}
          value={(details && details.packageDescr) || ''}
          required={false}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'DESI Effective Date'}
          value={(details && details.desiEffectiveDt) || ''}
          required={false}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Dosage Form'}
          value={(details && details.dosageFormDescr) || ''}
          required={false}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Previous NDC'}
          required={false}
          value={
            (details &&
              details.prevLabelerCode &&
              details.prevProductCode &&
              details.prevPackageSize &&
              `${details.prevLabelerCode}-${details.prevProductCode}-${details.prevPackageSize}`) ||
            ''
          }
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Strength Description'}
          required={false}
          value={(details && details.strengthDescr) || ''}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Replacement NDC'}
          required={false}
          value={
            (details &&
              details.replacementLabelerCode &&
              details.replacementProductCode &&
              details.replacementPackageSize &&
              `${details.replacementLabelerCode}-${details.replacementProductCode}-${details.replacementPackageSize}`) ||
            ''
          }
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Route of Administration'}
          required={false}
          value={
            details && details.drugRouteCd
              ? `${details.drugRouteCd} ${getValueFromReferenceData(
                  'DRUG_ROUTE_CD',
                  details.drugRouteCd
                )}`
              : ''
          }
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Form'}
          required={false}
          value={(details && details.formCd) || ''}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          required={false}
          label={'Drug Generic Name'}
          value={(details && details.drugGenericName) || ''}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'GCN'}
          required={false}
          value={(details && details.gcnSequenceNumber) || ''}
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Market Basket ID'}
          required={false}
          value={(details && details.txMbId) || ''}
        />
      </div>
      <div className='col-4'></div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'DRAMS Unit Type'}
          required={false}
          value={
            (details &&
              getValueFromReferenceData(
                'DRAMS_UNIT_TYPE_CD',
                details.dramsUnitTypeCd
              )) ||
            ''
          }
        />
      </div>
      <div className='col-4'>
        <NDCDetailsTextFieldComponent
          label={'Generic Code'}
          required={false}
          value={(details && details.genericCodeNumber) || ''}
        />
      </div>
      <div className='col-4'>
        <div className='form-wrapper vertical-wrapper'>
          <div className='mui-custom-form no-margin min-md w-100'>
            <div className='sub-radio text-black sub-label'>
              <CheckboxComponent
                label={'Family Planning Data Exists'}
                checked={
                  details && details.familyPlanningInd === 1 ? true : false
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabNDCDetailsInputContainer;
